module.exports = __webpack_public_path__ + "media/images/dialpad-icon-c6d2fe3cc73ec7a68c122c0edcbf2d8d.svg";